// $(document).ready(function(){
//   $(".upcart-header-close-button").click(function(){
//      $('body').removeClass('overflow-hidden');
//   })
// })
$(document).ready(function() {
  // Shopify app ma click kariye to class remove karo
  $(document).on("click", ".upcart-header-close-button,.styles_CartPreview__backdrop__", function() {
    $('body').removeClass('overflow-hidden');
  });
});





// 
// custom script - satyam
// 
var productSwiper = null; // Initialize swiper as null
function createSlider() {
  if (window.innerWidth <= 749) {
    if (!productSwiper) {
      productSwiper = new Swiper(".productSwiper", {
        pagination: {
          el: ".productSwiper .swiper-pagination",
          clickable: true,
        },
      });
    }
  } else {
    if (productSwiper) {
      productSwiper.destroy(true, true);
      productSwiper = null;
    }
  }
}

// Initial call to create or destroy the slider based on window width
createSlider();

// Listen for window resize events and update the slider accordingly
window.addEventListener("resize", createSlider);

//====================Sticky-add-to-cart
// Wait for the DOM to load
document.addEventListener('DOMContentLoaded', function() {
  const addToCartBtn = document.querySelector('.add_to_cart_btn');
  const stickyCart = document.querySelector('.sticky_cart');

  if (addToCartBtn && stickyCart) {
    // Function to check scroll position
    const toggleStickyCart = () => {
      const addToCartRect = addToCartBtn.getBoundingClientRect();
      if (addToCartRect.bottom < 0) {
        stickyCart.style.display = 'block';
      } else {
        stickyCart.style.display = 'none';
      }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', toggleStickyCart);

    // Initialize the sticky cart visibility
    toggleStickyCart();
  } else {
    console.error('Required elements not found: .add_to_cart_btn or .sticky_cart');
  }
});

//====================heading-same-height
document.addEventListener('DOMContentLoaded', function() {
var elements = document.querySelectorAll('.card__heading a');
var maxHeight = -1;

// Find the maximum height
elements.forEach(function(element) {
var height = element.getBoundingClientRect().height;
if (height > maxHeight) {
maxHeight = height;
}
});

// Set the minimum height for each element
elements.forEach(function(element) {
element.style.minHeight = maxHeight + 'px';
});
});

//====================Review-content
// document.addEventListener('DOMContentLoaded', function() {
// var elements = document.querySelectorAll('.review_content');
// var maxHeight = -1;

// // Find the maximum height
// elements.forEach(function(element) {
// var height = element.getBoundingClientRect().height;
// if (height > maxHeight) {
// maxHeight = height;
// }
// });

// // Set the minimum height for each element
// elements.forEach(function(element) {
// element.style.minHeight = maxHeight + 'px';
// });
// });

//==================ingredient_slider
if (document.getElementById("ingredient_slider")) {
  var swiper = new Swiper("#ingredient_slider", {
    slidesPerView: 1.1,
    spaceBetween: 6,
    freeMode: false,
    // slidesPerView: "auto",
    pagination: {
      el: "#ingredient_slider .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      575: {
        freeMode: false,
        slidesPerView: 1.5,
        spaceBetween: 6,
      },
      768: {
        freeMode: false,
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        freeMode: false,
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
}

//=====collection__slider
if (document.getElementById("collection__slider")) {
  var swiper = new Swiper("#collection__slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    freeMode: true,
    // slidesPerView: "auto",
    pagination: {
      el: "#collection__slider .swiper-pagination",
      clickable: true,
    },
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    breakpoints: {
     575: {
        freeMode: false,
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        freeMode: false,
        slidesPerView: 2,
        spaceBetween: 16,
      },
      991: {
        freeMode: false,
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1200: {
        freeMode: false,
        slidesPerView: 4,
        spaceBetween: 16,
      },
    },
  });
}

//=====featured_collection__slider
if (document.getElementById("featured_collection__slider")) {
  var swiper = new Swiper("#featured_collection__slider", {
    slidesPerView: 1.5,
    spaceBetween: 0,

    // slidesPerView: "auto",
    pagination: {
      el: "#featured_collection__slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      575: {
        freeMode: false,
        slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {
        freeMode: false,
        slidesPerView: 2.5,
        spaceBetween: 0,
      },
      991: {
        freeMode: false,
        slidesPerView: 3,
        spaceBetween: 0,
      },
       1200: {
        freeMode: false,
        slidesPerView:3.5,
        spaceBetween: 0,
      },
      1440: {
        freeMode: false,
        slidesPerView: 4,
        spaceBetween: 0,
      },
    },
  });
}

//=============review__slider
if (document.getElementById("review__slider")) {
  var swiper = new Swiper("#review__slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: false,
    pagination: {
      el: "#review__slider .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      575: {
        freeMode: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        freeMode: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        freeMode: false,
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });
}

// customer_survey_section

if(document.getElementById("customer_survey_slider")){
  var swiper = new Swiper("#customer_survey_slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    autoHeight: true,
    pagination: {
        el: "#customer_survey_slider .swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        600: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
  });
}

// insta_feed_slider
if(document.getElementById("insta_feed_slider")){
  var swiper = new Swiper("#insta_feed_slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    freeMode: true,
    slidesPerView: "auto",
    pagination: {
      el: "#insta_feed_slider .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
        575: {
          freeMode: false,
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          freeMode: false,
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          freeMode: false,
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
  });
}

// facet-checkbox
if(document.getElementById("Facet-1-template--16990007197945__product-grid")){
  const elements = document.querySelectorAll('#Facet-1-template--16990007197945__product-grid .facets__list .facets__item');
  const resetBtn = document.querySelector('#Facet-1-template--16990007197945__product-grid facet-remove');
  
  elements.forEach(function (element) {
    const checkboxElement = element.querySelector('.facet-checkbox [type="checkbox"]');
    const checkedCheckbox = Array.from(elements).filter(function (el) {
      return el.querySelector('.facet-checkbox [type="checkbox"]').checked;
    });
    if (checkedCheckbox.length > 0) {
      resetBtn.style.display = "block";
    } else {
      resetBtn.style.display = "none";
    }
    checkboxElement.addEventListener("change", function(event) {
      
      const checkedCheckboxes = Array.from(elements).filter(function (el) {
        return el.querySelector('.facet-checkbox [type="checkbox"]').checked;
      });
      if (checkedCheckboxes.length > 0) {
        resetBtn.style.display = "block";
      } else {
        resetBtn.style.display = "none";
      }
    });
  });

  resetBtn.addEventListener("click", function(event) {
    resetBtn.style.display = "none";
  });
}


// footer dropdown menu list

document.addEventListener('DOMContentLoaded', function () {
  // Get all the menu items
  var menuItems = document.querySelectorAll('.footer-menu-list li a');

  // Add click event listener to each menu item
  menuItems.forEach(function (menuItem) {
    menuItem.addEventListener('click', function () {
      this.classList.toggle('list-menu__item--active');
    });

    if(menuItem.classList.contains('list-menu__item--active')){
      if(menuItem.parentElement.parentElement.previousElementSibling.classList.contains('list-submenu__item--link')){
        menuItem.parentElement.parentElement.previousElementSibling.classList.add('list-menu__item--active');
      }
    }
  });
});

//======================Video-banner-play-pause
const video = document.getElementById("product_video");
const thumbnail = document.getElementById("video_play");

video.addEventListener("click", () => {
  if (video.paused) {
    video.play(); // Play video
    thumbnail.style.display = "none";
  } else {
    video.pause();
    thumbnail.style.display = "block";
  }
});


